export default __webpack_public_path__ + "static/media/BumpFund_Icons_01.fa54c24f.svg";